// extracted by mini-css-extract-plugin
export default {"Container":"SearchContainer_Container__X-yyo"};